import { isAxiosError } from "axios";

const DEACTIVATED_PLATFORM_ERROR = "deactivated_platform";

export const isDeactivatedPlatformError = (error: unknown) => {
  return (
    isAxiosError(error) &&
    error.response?.status === 401 &&
    error.response.data.error === DEACTIVATED_PLATFORM_ERROR
  );
};
